import { Text, Button } from "@asayinc/component-library";
import { Box, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";

import { PageContainer } from "src/components/containers/PageContainer/PageContainer";
import { ScrollContainer } from "src/components/containers/ScrollContainer";

export function PageNotFound() {
  const navigate = useNavigate();

  return (
    <PageContainer>
      <ScrollContainer
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
        }}
      >
        <Stack alignItems="center" spacing={4}>
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              backgroundColor: "#F3F4F6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <SearchOffOutlinedIcon sx={{ fontSize: 40, color: "#6B7280" }} />
          </Box>
          <Text variant="h4">Page Not Found</Text>
          <Text
            variant="body1"
            sx={{ color: "text.secondary", textAlign: "center", maxWidth: 400 }}
          >
            The page you&apos;re looking for doesn&apos;t exist or may have been
            moved.
          </Text>
          <Button variant="primary" onClick={() => navigate("/dashboard")}>
            Go to Dashboard
          </Button>
        </Stack>
      </ScrollContainer>
    </PageContainer>
  );
}
